import React from "react";
import { useSearch } from "../../../Contexts/SearchContext";

const Filter = ({ filter, updateFilters, count }) => {
  const { state, dispatch } = useSearch();
  
  return (
    <>
      {filter && (
        <label key={filter.tagPath} className={`${!count  ? "hide" : ""}`}>
          <input
            type="checkbox"
            class="category_filters"
            value={filter.tagPath}
            data-heading-filter-title={filter.label}
            key={filter.tagPath}
            onChange={(e) => {
              updateFilters(e);
            }}
          />
          <p>{filter.label} 
            <span className="filter-count">
              ({count})
            </span>
          </p>
        </label>
      )}
    </>
  );
};

export default Filter;
